//#region src/enums/channelPartnerKeyScopeKey.ts
var e = (e) => e.replace(/[:.]/g, "_");
//#endregion
export { e as channelPartnerKeyScopeKey };
